import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const fetchProducts = async () => (await api.get("/products")).data;
export const sendContact = async (payload) => (await api.post("/contact", payload)).data;

export const login = async (email, password) =>
  (await api.post("/auth/login", { email, password })).data;
export const logout = async () => (await api.post("/auth/logout")).data;
export const fetchMe = async () => (await api.get("/auth/me")).data;

export const adminCreateProduct = async (payload) =>
  (await api.post("/admin/products", payload)).data;
export const adminUpdateProduct = async (id, payload) =>
  (await api.put(`/admin/products/${id}`, payload)).data;
export const adminDeleteProduct = async (id) =>
  (await api.delete(`/admin/products/${id}`)).data;
export const adminPatchProduct = async (id, patch) =>
  (await api.patch(`/admin/products/${id}`, patch)).data;
export const adminReorderProducts = async (ids) =>
  (await api.post("/admin/products/reorder", { ids })).data;
export const adminUploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};
export const fetchSettings = async () => (await api.get("/site-settings")).data;
export const adminUpdateSettings = async (payload) =>
  (await api.put("/admin/site-settings", payload)).data;

export const adminListContacts = async () => (await api.get("/admin/contacts")).data;
export const adminUpdateContactStatus = async (id, status) =>
  (await api.patch(`/admin/contacts/${id}`, { status })).data;
export const adminDeleteContact = async (id) =>
  (await api.delete(`/admin/contacts/${id}`)).data;

export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/uploads/")) return `${BACKEND_URL}${url}`;
  return url;
};
